export default __webpack_public_path__ + "0e08fe87ae2b43901f5c22246096ef76.svg";